"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }





var _time = require('shared/services/time');

/* P2': helpers for a campaign's background CSV Add. */

/* The reply to AddCampaignRecipients when the Add went to the background. */
 const isBackgroundAddReply = (
  r,
) => 'Add' in r && !!r.Add; exports.isBackgroundAddReply = isBackgroundAddReply

 const isAddRunning = (add) =>
  _optionalChain([add, 'optionalAccess', _ => _.State]) === 'running'; exports.isAddRunning = isAddRunning

/* Ended before writing every row. */
 const isAddStopped = (state) =>
  state === 'failed' || state === 'interrupted'; exports.isAddStopped = isAddStopped

/* Rows done, as a whole percentage (100 only once every row is done). */
 const addPercent = (add) => {
  if (add.TotalRows <= 0) return 0
  if (add.RowsDone >= add.TotalRows) return 100
  return Math.max(0, Math.min(99, Math.floor((add.RowsDone / add.TotalRows) * 100)))
}; exports.addPercent = addPercent

/* Pushes and reads can arrive out of order: keep the newest Add, and the
 * newest progress of the same Add; an ended Add never goes back to running.
 * A push has no FailedRows, so the ones a read brought are kept. */
 const mergeAdd = (
  prev,
  next,
) => {
  if (!prev) return next
  if (prev.TaskKey !== next.TaskKey) return _time.isAfter.call(void 0, prev.StartedAt, next.StartedAt) ? prev : next
  if (prev.State !== 'running' && next.State === 'running') return prev
  const isPrevNewer = prev.State === next.State && _time.isAfter.call(void 0, prev.UpdatedAt, next.UpdatedAt)
  const newer = isPrevNewer ? prev : next
  const FailedRows = _nullishCoalesce(next.FailedRows, () => ( prev.FailedRows))
  return FailedRows ? { ...newer, FailedRows } : newer
}; exports.mergeAdd = mergeAdd

/* A different Add, or the same one in a new state: the campaign's
 * recipients and variables may have changed, so a loaded campaign is read
 * again. */
 const isNewAddState = (
  before,
  after,
) => !!after && (!before || before.TaskKey !== after.TaskKey || before.State !== after.State); exports.isNewAddState = isNewAddState
